require('./modifyCommerceAndATMLimitsView.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { formatText, FormattedText } = require('core/i18n').i18n;
// @helpers

// @components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');

const ModifyCommerceAndATMLimitsStep1 = require('./modifyCommerceAndATMLimitsStep1/modifyCommerceAndATMLimitsStep1');
const ModifyCommerceAndATMLimitsStep2 = require('./modifyCommerceAndATMLimitsStep2/modifyCommerceAndATMLimitsStep2');

const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
const { ModalCustom } = require('commonsComponents/modalCustom');

// @constants
const { WIZARD_VERTICAL_VIEW_MODE, FIRST_STEP } = require('constants/index');
const { MODIFY_COMMERCE_AND_ATM_LIMITS } = require('constants/contactCenter/operationTypes');

const translationNamespace = 'modifyCommerceAndATMLimits';
const printTitleValue = "modifyCommerceAndATMLimits-printPreviewTitle";

class ModifyCommerceAndATMLimitsView extends React.Component {
    constructor(props) {
        super(props);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleHideCancelModal = this.handleHideCancelModal.bind(this);
        this.handleHideWarningModal = this.handleHideWarningModal.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onHandleGoBack = this.onHandleGoBack.bind(this);
    }

    componentDidMount() {
        const { immCard, setLimitRanges } = this.props;
        const cardSubType = immCard.getIn(['product', 'subtype']);
        setLimitRanges(cardSubType);
    }

    componentWillUnmount() {
        this.props.reset();
    }

    buildPreleaveCancelModal() {
        const { immModifyCommerceAndATMLimits } = this.props;
        const showCancelModal = immModifyCommerceAndATMLimits.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={showCancelModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleHideCancelModal}
                onStayHere={this.handleHideCancelModal}
            />
        );
    }

    buildWarningModal() {
        const { immModifyCommerceAndATMLimits } = this.props;
        const showWarningModal = immModifyCommerceAndATMLimits.getIn(['steps', FIRST_STEP, 'showWarningModal']);
        const acceptLabel = formatText('modifyCommerceAndATMLimits-warningModalAccept');

        return (
            <ModalCustom
                isOpen={showWarningModal}
            >
                <section className="modify-commerce-and-atm-limits__warning-modal">
                    <FormattedText
                        className="modify-commerce-and-atm-limits__warning-modal-title"
                        value="modifyCommerceAndATMLimits-warningModalTitle" />
                    <FormattedText
                        className="modify-commerce-and-atm-limits__warning-modal-subtitle"
                        value="modifyCommerceAndATMLimits-warningModalSubtitle" />
                    <div className="modify-commerce-and-atm-limits__warning-modal-button">
                        <OKButton onClick={this.handleHideWarningModal}>
                            <span>{acceptLabel}</span>
                        </OKButton>
                    </div>
                </section>
            </ModalCustom>
        );
    }

    handleShowCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(true);
    }

    handleHideCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(false);
    }

    handleHideWarningModal() {
        const { hideWarningModal } = this.props;
        hideWarningModal();
    }

    handleCancel() {
        const { match: { params: { cardId } }, history } = this.props;
        const cancelPath = `/myprofile/cards/${cardId}/details`;
        history.push(cancelPath);
    }

    onHandleGoBack() {
        const cancelPath = `/myprofile/cards`;
        this.props.history.push(cancelPath);
    }

    buildHeader() {
        const title = formatText(`modifyCommerceAndATMLimits-title`);
        const { match: { params: { cardId, type } }, immCard } = this.props;
        const breadcrumpMap = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.getIn(['alias', 'current']),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardDetails-title'),
                url: `/myprofile/cards/${cardId}/details`
            },
            {
                text: formatText(`modifyCommerceAndATMLimits-${type}Title`),
            }
        ];

        return (
            <OKHeaderCC
                title={title}
                breadcrumbConfig={breadcrumpMap}
                showBreadBrumb={true}
            />
        );
    }

    handleFinish() {
        const { match: { params: { cardId } }, confirmModifyCommerceAndATMLimits } = this.props;
        confirmModifyCommerceAndATMLimits(cardId);
    }

    buildSuccessfulFeedback() {
        const { match: { params: { type } } } = this.props;
        return (
            <CustomMessageBox
                icon="icon-success"
                title={formatText(`${translationNamespace}-${type}SuccessfulFeedbackTitle`)}
                subtitle={formatText(`${translationNamespace}-successfulFeedbackSubtitle`)}
                textLink={formatText(`${translationNamespace}-feedbackBackButton`)}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildErrorFeedback() {
        const { match: { params: { type } } } = this.props;

        return (
            <CustomMessageBox
                icon="icon-warning"
                title={formatText(`${translationNamespace}-${type}FailureFeedbackTitle`)}
                textLink={formatText(`${translationNamespace}-feedbackBackButton`)}
                goBackHandler={this.onHandleGoBack}
            />
        );
    }

    buildWizard() {
        const {
            match: { params: { type } },
            setVisibleStep,
            validateStep,
            immModifyCommerceAndATMLimits,
            immCard,
            setLimitAmount
        } = this.props;

        const currentStep = immModifyCommerceAndATMLimits.get('currentStep');
        const immSteps = immModifyCommerceAndATMLimits.get('steps');
        const isFetching = immModifyCommerceAndATMLimits.get('isFetching');

        const actions = {
            finish: this.handleFinish,
            setVisibleStep,
            validateStep,
            setWillCancel: () => { },
            cancel: this.handleShowCancelModal
        };

        const operationParams = {
            ammount: immModifyCommerceAndATMLimits.getIn(['steps', FIRST_STEP, 'newSelectedLimit']),
            currency: immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'importeLimiteActual', 'divisa']),
            pan: immCard.get('number'),
            optional1: immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'codigoLimite']),
        };

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={currentStep}
            >
                <WizardStep
                    cancelButton={true}
                >
                    <ModifyCommerceAndATMLimitsStep1
                        immCard={immCard}
                        limitType={type}
                        immModifyCommerceAndATMLimits={immModifyCommerceAndATMLimits}
                        setLimitAmount={setLimitAmount}
                    />
                </WizardStep>

                <WizardStep
                    position="middle"
                    omitPreviousButton={false}
                    cancelButton={true}
                    addLoadingBehaviour={false}
                >
                    <ModifyCommerceAndATMLimitsStep2
                        immCard={immCard}
                        limitType={type}
                        immModifyCommerceAndATMLimits={immModifyCommerceAndATMLimits}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton={false}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={isFetching}
                    immFinalButton={`${translationNamespace}-confirm`}
                >
                    <VerifyOtpStep
                        operationType={MODIFY_COMMERCE_AND_ATM_LIMITS}
                        operationParams={operationParams}
                        printTitleValue={printTitleValue}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildContent() {
        const { immModifyCommerceAndATMLimits } = this.props;
        let pageContent;

        if (immModifyCommerceAndATMLimits.get('hasBeenFetched')) {
            pageContent = this.buildSuccessfulFeedback();
        } else if (immModifyCommerceAndATMLimits.get('error')
            || immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'error'])
            || immModifyCommerceAndATMLimits.getIn(['limitsData', 'error'])) {
            pageContent = this.buildErrorFeedback();
        } else if (
            immModifyCommerceAndATMLimits.get('isFetching') ||
            immModifyCommerceAndATMLimits.getIn(['limitsData', 'isFetching'])
        ) {
            pageContent = (
                <LoadingSection />
            );
        } else if (immModifyCommerceAndATMLimits.getIn(['limitsData', 'data', 'codigoLimite'])) {
            const wizard = this.buildWizard();
            const warningModal = this.buildWarningModal();
            const preleaveCancelModal = this.buildPreleaveCancelModal();
            const content = (
                <div className="modify-commerce-and-atm-limits__content col-xs-12">
                    {wizard}
                    {preleaveCancelModal}
                    {warningModal}
                </div>
            );
            pageContent = (
                <div>
                    {content}
                </div>
            );
        }

        return pageContent;
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <div className="modify-commerce-and-atm-limits">
                {header}
                <div className="modify-commerce-and-atm-limits__body">
                    {content}
                </div>
            </div>

        );
    }
}

ModifyCommerceAndATMLimitsView.propTypes = {
    history: PropTypes.object.isRequired,
    immModifyCommerceAndATMLimits: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setLimitAmount: PropTypes.func.isRequired,
    setLimitRanges: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    confirmModifyCommerceAndATMLimits: PropTypes.func.isRequired,
    hideWarningModal: PropTypes.func.isRequired,
};

module.exports = withRouter(ModifyCommerceAndATMLimitsView);
